import { ActionButtonCell, BadgeCell, DatetimeCell, TextCell } from "../components/DataTable";
import { faFolderOpen, faEdit, faCheckSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { generatePath } from 'react-router';
import { Routes } from '../Routes';
import { UnitQuery, DimensionQuery, MethodQuery, MaterialQuery, NonMaterialQuery, MatrixQuery, SamplePretreatmentQuery, OtherCriterionQuery } from './Components';
import { Permissions } from '../Permissions';
import { getPermission } from '../hooks';
import { Input, FormGroup } from 'reactstrap';
import { ComponentListResult, ComponentQueryListResult } from './ComponentGraphQLService.types';
import { ReleasesModal } from '../components/Common/Modals';
import { KomponentenStatusUtil } from '../api';
import { OptionalKomponentenTypEnum, ComponentPreviewModal, ComponentFormValues, KomponentenTypEnum } from '../components/ParamComponents';
import { Role } from '../Roles';
import { ColumnSortInfo } from '../components/DataTable/PCDataTable';
import { ComponentQueryResult } from './Components/ComponentQuery';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

/**
 * this service provides queries and table columns for Komponenten 
 */
class ComponentGraphQLServiceImpl {

  public getComponent(componentType: OptionalKomponentenTypEnum): DocumentNode {
    console.log('type', componentType);
    switch(componentType) {
      case KomponentenTypEnum.Dimension:
        return DimensionQuery.getComponent();
      case KomponentenTypEnum.Methode:
        return MethodQuery.getComponent();
      case KomponentenTypEnum.Einheit:
        return UnitQuery.getComponent();
      case KomponentenTypEnum.Stoff:
        return MaterialQuery.getComponent();
      case KomponentenTypEnum.Nichtstofflich:
        return NonMaterialQuery.getComponent();
      case KomponentenTypEnum.Matrix:
        return MatrixQuery.getComponent();
      case KomponentenTypEnum.SonstigesKriterium:
        return OtherCriterionQuery.getComponent();
      case KomponentenTypEnum.Probenvorbehandlung:
        return SamplePretreatmentQuery.getComponent();
      default:
        // default DocumentNode is necessary
        return gql`query {
          __schema { description }
        }` 
    }
  }

  /**
   * @param componentType 
   * @param filter 
   */
  public getComponentList(role: string, componentType?: OptionalKomponentenTypEnum, filter?: ComponentFormValues): ComponentListResult {
    if(componentType === undefined || filter === undefined) {
      return {
        filter: undefined,
        columns: []
      };
    }
    filter.kind = componentType;
    switch(componentType) {
      case KomponentenTypEnum.Dimension:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: DimensionQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.Stoff:
        return {  
          columns: this.getColumns(role, componentType, false),
          filter: MaterialQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.Nichtstofflich:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: NonMaterialQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.Einheit:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: UnitQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.Probenvorbehandlung:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: SamplePretreatmentQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.SonstigesKriterium:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: OtherCriterionQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.Methode:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: MethodQuery.getFilter(role,filter)
        };
      case KomponentenTypEnum.Matrix:
        return {
          columns: this.getColumns(role, componentType, false),
          filter: MatrixQuery.getFilter(role,filter)
        };
      default:
        return {
          columns: [],
          filter: undefined
        };
    }
  }

  public getComponentQuery(componentType?: OptionalKomponentenTypEnum, sortBy?: ColumnSortInfo[]): ComponentQueryResult {
    if(componentType === undefined) {
      return { query: undefined, sort: undefined };
    }
    switch(componentType) {
      case KomponentenTypEnum.Dimension:
        return DimensionQuery.getComponentList(sortBy);
      case KomponentenTypEnum.Stoff:
        return MaterialQuery.getComponentList(sortBy);
      case KomponentenTypEnum.Nichtstofflich:
        return NonMaterialQuery.getComponentList(sortBy);
      case KomponentenTypEnum.Einheit:
        return UnitQuery.getComponentList(sortBy);
      case KomponentenTypEnum.Probenvorbehandlung:
        return SamplePretreatmentQuery.getComponentList(sortBy);
      case KomponentenTypEnum.SonstigesKriterium:
        return OtherCriterionQuery.getComponentList(sortBy);
      case KomponentenTypEnum.Methode:
        return MethodQuery.getComponentList(sortBy);
      case KomponentenTypEnum.Matrix:
        return MatrixQuery.getComponentList(sortBy);
    }

  }

  /**
   * TODO solve this with polymorphie 
   * @param componentType
   * @param idList 
   */
  public getComponentListDuplicates(role: string, componentType: OptionalKomponentenTypEnum, codeList: string[]): ComponentQueryListResult {
    switch(componentType) {
      case KomponentenTypEnum.Dimension:
        return {
          ...DimensionQuery.getComponentList(),
          filter: DimensionQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.Stoff:
        return {
          ...MaterialQuery.getComponentList(),
          filter: MaterialQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.Nichtstofflich:
        return {
          ...NonMaterialQuery.getComponentList(),
          filter: NonMaterialQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.Einheit:
        return {
          ...UnitQuery.getComponentList(),
          filter: UnitQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.Probenvorbehandlung:
        return {
          ...SamplePretreatmentQuery.getComponentList(),
          filter: SamplePretreatmentQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.SonstigesKriterium:
        return {
          ...OtherCriterionQuery.getComponentList(),
          filter: OtherCriterionQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.Methode:
        return {
          ...MethodQuery.getComponentList(),
          filter: MethodQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      case KomponentenTypEnum.Matrix:
        return {
          ...MatrixQuery.getComponentList(),
          filter: MatrixQuery.getFilterDuplicates(codeList),
          columns: this.getColumns(role, componentType, true)
        };
      default:
        return {
          query: undefined,
          // variables: undefined,
          columns: []
       };
    }
  } 


  /**
   *
   */
  private getColumns(role: string, componentType: KomponentenTypEnum, duplicates: boolean): any[] {
    const columns: any = [];
    if(!duplicates) {
      columns.push({
        id: 'selection',
        Header: ({ getToggleAllRowsSelectedProps }) => {
          return (
            <FormGroup check inline className="pl-3 pt-2">
              <Input type="checkbox" aria-label="Alle Elemente auf dieser Seite Auswählen" {...getToggleAllRowsSelectedProps({ title: 'Alle Elemente auf dieser Seite auswählen'})} />
              <span className="sr-only">Alle Auswählen</span>
            </FormGroup>
          );
        },
        Cell: ({ row }) => {
          return ( // React.createElement('input', {type: 'checkbox', ...row.getToggleRowSelectedProps()})
          <FormGroup check inline className="pl-3 pt-2">
            <Input type="checkbox" aria-label="Zeile auswählen" {...row.getToggleRowSelectedProps({ title: 'Zeile auswählen'})} />
          </FormGroup>
        );
        }
      });
    }
    columns.push(this.getActionColumns(role, componentType, duplicates));
    columns.push({ 
      Header: 'Code',
      accessor: 'code',
      Cell: ({row, column}) => {
        if(row.original.status !== KomponentenStatusUtil.KS1.id || role === Role.EHPC_RW) {
          return row.original.code;
        }
        return '';
       }
    });
    columns.push({ Header: 'Name', accessor: 'name'});
    switch(componentType) {
      case 'DIMENSION':
        columns.push({ Header: 'Symbol', accessor: 'symbol' });
        break;
      case 'EINHEIT':
        columns.push({ Header: "Symbol", accessor: 'symbol' });
        columns.push({ Header: "ISO Code", accessor: 'isocode' });
        columns.push({ id: 'dimension.symbol', Header: 'Dimension', disableSortBy: true, accessor: (row) => DimensionQuery.getDropdownLabel(row.dimension)})
        break;
      case 'METHODE':
        columns.push({ 
          Header: "Titel", 
          accessor: 'titel',
          Cell: ({row, column}) => { return (<TextCell row={row} column={column} className="d-inline-block text-truncate" style={{ maxWidth: 500 }} />) }
        });
        columns.push({ 
          Header: "Gültig ab", 
          accessor: 'gueltigAb',
          Cell: ({row, column}) => { return <DatetimeCell row={row} column={column} dateFormat="" timeFormat="" /> }
        });
        break;
      case 'STOFF':
        columns.push({ Header: "CAS Nr", accessor: 'casNummer' });
        columns.push({ Header: "EU Nr", accessor: 'egNummer' });
        columns.push({ Header: "Summenformel", accessor: 'formel' });
        columns.push(
          {
            Header: 'Alternativname(n)',
            disableSortBy: true,
            accessor: 'alternativnamen',
            Cell: ({ row, column }) => {
              return <BadgeCell column={column} row={row} />
            }
          }
        );
        break;
    }
    columns.push({Header: 'Status', id: 'status', accessor: (d: any) => KomponentenStatusUtil.getStatus(d.status)?.name});
    columns.push({
      Header: 'erstellt am', 
      accessor: 'createdDate',
      Cell: ({row, column}) => { return <DatetimeCell row={row} column={column} dateFormat="" timeFormat="" /> }
    });
    columns.push({
      Header: 'zuletzt geändert', 
      accessor: 'lastModifiedDate',
      Cell: ({row, column}) => { return <DatetimeCell row={row} column={column} dateFormat="" timeFormat="" /> }
    });

    return columns;
  }

  private getActionColumns(role: string, componentType: string, duplicates: boolean): any {
    const permCompRead = getPermission(role, [Permissions.ParameterKomponenteRead]);
    const permCompUpdate = getPermission(role, [Permissions.ParameterKomponenteUpdate]);
    const permCompRelease = getPermission(role, [Permissions.ParameterKomponenteRelease]);
    const permCompDelete = getPermission(role, [Permissions.ParameterKomponenteDelete]);
    const actionColumns: any = [];

    const componentTypeRoute = componentType ?? '/';

    // for duplicates return a single read column
    if (duplicates) {
      return {
        id: 'action',
        Header: 'Aktion',
        Cell: ({ row, column }) => {
          return (
            <ActionButtonCell row={row} column={column} icon={faFolderOpen}
              tooltip="Ansehen"
              modal={(open: boolean, setOpen: Function, element: any) => 
                <ComponentPreviewModal
                  open={open} setOpen={setOpen}
                  element={element}
                  headerId="modal_header_components_preview" />}
            />
          );
        }
      }
    }

    if(permCompRead) {
      actionColumns.push( { 
        id: 'action-open',
        Header: <span className="sr-only">Aktion Ansehen</span>,
        Cell: ({ row, column}) => {
          return (
            <ActionButtonCell row={row} column={column} icon={faFolderOpen}
              tooltip="Ansehen"
              to={generatePath(Routes.ComponentRead, {componentId: row.original.id, componentType: componentTypeRoute })} />
          );}
      });
    }

    if (permCompUpdate) {
      actionColumns.push({ 
        id: 'action-edit',
        Header: <span className="sr-only">Aktion Bearbeiten</span>,
        Cell: ({ row, column}) => {
          return (
            <ActionButtonCell  row={row} column={column} icon={faEdit}
              tooltip="Bearbeiten"
              disabled={(role !== Role.EHPC_RW)}
              to={generatePath(Routes.ComponentEdit, {componentId: row.original.id, componentType: componentTypeRoute })} />
          );}
      });
    }

    if (permCompRelease) {

      actionColumns.push({ 
        id: 'action-release',
        Header: <span className="sr-only">Aktion Freigeben</span>,
        Cell: ({ row, column}) => {
          if(row.original.status === KomponentenStatusUtil.KS2A.id) {
            return null;
          }
          return (
            <ActionButtonCell  row={row} column={column} color="release" icon={faCheckSquare}
              tooltip="Freigeben"
              modal={(open: boolean, setOpen: Function, element: any) =>
                <ReleasesModal open={open} setOpen={setOpen} items={[element]} type={componentType ?? ''} />}
            />
          );}
      });
    }

    if (permCompDelete) {
      actionColumns.push({ 
        id: 'action-delete',
        Header: <span className="sr-only">Aktion Löschen</span>,
        Cell: ({ row, column}) => {
          return (
            <ActionButtonCell  row={row} column={column} color="delete" icon={faTrash}
              tooltip="Löschen"
              to={generatePath(Routes.ComponentDelete, {componentId: row.original.id, componentType: componentTypeRoute })} />
          );}
      });
    }

    return {
      Header: 'Aktionen',
      canSort: false,
      columns: actionColumns,
    };

  }
}

export const ComponentGraphQLService = new ComponentGraphQLServiceImpl();
